export default {
      id: "app-store-usage",
      viewBox: "0 0 147 40",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#app-store",
      toString: function () {
        return this.url;
      }
    }